// Lehigh University's undergraduate majors (#2748). Read on 2026-10-01
// from the official 2026-27 Catalog's "Programs and Majors" page
// (catalog.lehigh.edu/programsandmajors/): every entry under "Undergraduate
// Academic Majors" and "Cross-Disciplinary Programs"; graduate majors left
// out. Each major is grouped by the college whose catalog section it links
// to (College of Arts and Sciences, College of Business, P.C. Rossin
// College of Engineering and Applied Science, College of Health); the
// Integrated Business and Health major links to a Lehigh web page rather
// than a college section, so it sits with the cross-disciplinary programs.
// The list names no degree types, so `degree` is null throughout (several
// majors lead to a B.A. or a B.S. depending on the college). Names are the
// catalog's own. The KB's majors list was the starting point; the catalog
// wins.
const majors = {
    "slug": "lehigh-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major and cross-disciplinary program in Lehigh's official 2026-27 Catalog, grouped by the college whose section lists it. The catalog's list does not name degree types. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Lehigh University 2026-27 Catalog, Programs and Majors",
                "url": "https://catalog.lehigh.edu/programsandmajors/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Asian and Asian American Studies",
                    "degree": null
                },
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Cognitive Science",
                    "degree": null
                },
                {
                    "name": "Design",
                    "degree": null
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Global Studies",
                    "degree": null
                },
                {
                    "name": "Health, Medicine, and Society",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Journalism/Science Writing",
                    "degree": null
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Pharmaceutical Chemistry",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religion, Culture and Society",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Sociology and Anthropology",
                    "degree": null
                },
                {
                    "name": "Spanish and Hispanic Studies",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "Lehigh University 2026-27 Catalog, Programs and Majors",
                "url": "https://catalog.lehigh.edu/programsandmajors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Business Information Systems",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "P.C. Rossin College of Engineering and Applied Science",
            "source": {
                "label": "Lehigh University 2026-27 Catalog, Programs and Majors",
                "url": "https://catalog.lehigh.edu/programsandmajors/"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": null
                },
                {
                    "name": "Bioengineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Engineering Mechanics",
                    "degree": null
                },
                {
                    "name": "Engineering Physics",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Health",
            "source": {
                "label": "Lehigh University 2026-27 Catalog, Programs and Majors",
                "url": "https://catalog.lehigh.edu/programsandmajors/"
            },
            "majors": [
                {
                    "name": "Biostatistics & Health Data Science",
                    "degree": null
                },
                {
                    "name": "Community and Global Health",
                    "degree": null
                },
                {
                    "name": "Population Health",
                    "degree": null
                }
            ]
        },
        {
            "name": "Cross-disciplinary programs",
            "source": {
                "label": "Lehigh University 2026-27 Catalog, Programs and Majors",
                "url": "https://catalog.lehigh.edu/programsandmajors/"
            },
            "majors": [
                {
                    "name": "Integrated Business and Health (IBH)",
                    "degree": null
                },
                {
                    "name": "Arts and Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science and Business (CSB)",
                    "degree": null
                },
                {
                    "name": "Elementary and Secondary Education (5-year program)",
                    "degree": null
                },
                {
                    "name": "Integrated Business and Engineering (IBE)",
                    "degree": null
                },
                {
                    "name": "Integrated Degree in Engineering, Arts and Sciences",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
